import { produce } from 'immer';

const INITIAL_STATE = {
  documents: null,
  total: 0,
  loading: false,
};

export default function documentRepairLogs(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@documentRepairLogs/GET_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@documentRepairLogs/GET_SUCCESS': {
        draft.documents = action.payload.data.content;
        draft.total = action.payload.data.total;
        draft.loading = false;
        break;
      }
      case '@documentRepairLogs/FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}
